
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forms/quiz",
      function () {
        return require("private-next-pages/forms/quiz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forms/quiz"])
      });
    }
  